import React from "react";

export function Heading({ as, children, className, style }) {
  const Component = as || "h3";
  return (
    <Component style={style} className={className}>
      {children}
    </Component>
  );
}
